<agc-form [formGroup]="form" (submit)="submit()">
  <div class="row m-b-20">
    <div class="col-md-12">
      <h3 class="text-center">Forgot Password?</h3>
    </div>
  </div>

  <agc-form-field>
    <input type="text" formControlName="email" autocomplete="username" class="form-control" required email placeholder="Your Email Address">
    <agc-message when="required">Email address is required.</agc-message>
    <agc-message when="email">Email does not appear to be valid.</agc-message>
  </agc-form-field>

  <div class="m-t-30">
    <button type="submit" class="btn btn-primary btn-md btn-block waves-effect waves-light text-center m-b-20">Continue &raquo;</button>
  </div>

  <hr>

  <p class="text-inverse text-center m-b-0">
    Already an agent? <a [routerLink]="['/']"><b class="f-w-600">Sign In</b></a>
  </p>
</agc-form>
